export default {
  publicExam_pass_score:'及格',
  publicExam_number_participants:'已參與人數',
  publicExam_total_score:"滿分{totalScoreStr}",
  publicExam_min_score:'及格{minScoreStr}',
  publicExam_totalTestNum:'已參與人數{totalTestNum}',
  publicExam_current_tab:'還沒有{currentTab}'
}

